import { SortAttributes } from '@markant-platform/shared/table/model';

export enum FileMetaInformationCategory {
  DOCUMENT = 'DOCUMENT',
  SERVICE_CONDITIONS = 'SERVICE_CONDITIONS',
  CREDIT_NOTE = 'CREDIT_NOTE',
  INVOICE = 'INVOICE',
}

export interface FileMetaInformation {
  id: string;
  name: string;
  cartridgeVariantId?: string;
  category: FileMetaInformationCategory;
  uploader: string;
  cartridgeName?: string;
  cartridgeVariantName?: string;
  uploadDate: Date;
  changed: Date;
  format: string;
}

export type FileCartridgeInformation = {
  variantId: string;
  name: string;
  variantName: string;
};

export interface FileUpload {
  file: File;
  format: string;
}

export interface FileMetaInformationParameters {
  index: number;
  size: number;
  search: string;
  filter: string;
  sort?: SortAttributes;
}
